import { useLiveViewStateStore } from '../LiveViewStore'
import { useSupportedFunctionalities } from './useSupportedFunctionalities'

export const useLiveViewError = () => {
    const { baseURL, errorMessage: storeErrorMessage, setErrorMessage, liveViewObject } = useLiveViewStateStore()
    const { IS_LIVE_VIEW_SUPPORTED } = useSupportedFunctionalities()

    const resetErrors = () => {
        setErrorMessage(null)
    }

    const handleSupportedFunctionalitiesError = (error: any) => {
        console.log(error)
        const status = error?.response?.status
        const detail =
            error?.response?.data?.detail ||
            error?.message ||
            error?.toJSON()?.message ||
            'Failed to communicate with device'

        if (status === 401 || status === 403) {
            setErrorMessage(
                'Authentication failed. If the device is not up to date, update it first; if it is already up to date or the issue continues after the update, contact AIoT.'
            )
        } else if (status === 502 || status === 504) {
            setErrorMessage(`${detail}: Check device network connection and power supply.`)
        } else {
            setErrorMessage(detail)
        }
    }

    if (!IS_LIVE_VIEW_SUPPORTED) {
        return {
            errorMessage: 'Live view is not supported on this device',
            handleSupportedFunctionalitiesError,
            resetErrors
        }
    }
    if (baseURL === 'FAILURE') {
        return {
            errorMessage: 'No live view url found',
            handleSupportedFunctionalitiesError,
            resetErrors
        }
    }
    if (!liveViewObject) {
        return {
            errorMessage:
                'Live view is not supported on this device, Device firmware version does not have a live view Section.',
            handleSupportedFunctionalitiesError,
            resetErrors
        }
    }

    return {
        errorMessage: storeErrorMessage,
        handleSupportedFunctionalitiesError,
        resetErrors
    }
}
